import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyPPOnboardingModal: FunctionComponent<{
  onComplete: () => void;
}> = ({ onComplete }) => {
  const PPOnboardingModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "personal-productivity-onboarding-modal" */ './PPOnboardingModal'
      ),
    { namedImport: 'PPOnboardingModal', preload: true },
  );

  return (
    <Suspense fallback={null}>
      <ChunkLoadErrorBoundary fallback={null}>
        <PPOnboardingModal onComplete={onComplete} />
      </ChunkLoadErrorBoundary>
    </Suspense>
  );
};
